import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useSettings } from "@/context/SettingsContext";
import { FaInstagram, FaTiktok, FaYoutube, FaXTwitter, FaTelegram, FaFacebook } from "react-icons/fa6";

export function Footer() {
  const { settings } = useSettings();
  const social = settings?.social_links || {};
  const socials = [
    { key: "instagram", Icon: FaInstagram }, { key: "tiktok", Icon: FaTiktok },
    { key: "youtube", Icon: FaYoutube }, { key: "twitter", Icon: FaXTwitter },
    { key: "telegram", Icon: FaTelegram }, { key: "facebook", Icon: FaFacebook },
  ].filter((s) => social[s.key]);
  const legal = [
    ["Gizlilik Politikası", "/gizlilik-politikasi"], ["Kullanım Koşulları", "/kullanim-kosullari"],
    ["İade ve İptal", "/iade-ve-iptal"], ["KVKK", "/kvkk"], ["İletişim", "/iletisim"],
  ];
  return (
    <footer className="border-t border-white/10 bg-[#171922] pb-24 md:pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <Logo className="h-8 mb-4" />
          <p className="text-sm text-gray-400 leading-relaxed">{settings?.footer_description}</p>
          <div className="flex gap-3 mt-4">
            {socials.map(({ key, Icon }) => (
              <a key={key} href={social[key]} target="_blank" rel="noreferrer"
                className="w-9 h-9 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-gray-300 hover:text-white hover:bg-white/10 transition-colors"
                data-testid={`footer-social-${key}`}>
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-3 text-sm">Hızlı Bağlantılar</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><Link to="/siparis-ver" className="hover:text-white">Sipariş Ver</Link></li>
            <li><Link to="/siparis-takip" className="hover:text-white">Sipariş Takip</Link></li>
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
            <li><a href={settings?.support_url || "#"} className="hover:text-white">Destek</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-3 text-sm">Yasal</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            {legal.map(([label, to]) => (
              <li key={to}><Link to={to} className="hover:text-white">{label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-3 text-sm">İletişim</h4>
          <p className="text-sm text-gray-400">Sorularınız için 7/24 canlı destek ekibimiz yanınızda.</p>
          <a href={settings?.support_url || "#"} target="_blank" rel="noreferrer"
            className="inline-block mt-3 text-sm font-semibold text-[#d8b4fe] hover:underline">Destek Al →</a>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center text-xs text-gray-500"
        dangerouslySetInnerHTML={{ __html: settings?.footer_html || `© ${new Date().getFullYear()} TakipciSatis.com — Tüm hakları saklıdır.` }} />
    </footer>
  );
}
